import React from 'react';
import * as Opt from '../editor/Helpers';
import MediaSelector from '../editor/fields/MediaSelector';
import TextEditor from '../editor/fields/TextEditor';
import ColorSelector from '../editor/fields/ColorSelector';

class FeaturesLayout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    const numCols = Math.min(4, Math.max(1, Number(this.props.numberColumns) || 1));
    const lgWidthClass = {
      1: 'lg:w-full',
      2: 'lg:w-[calc(50%-10px)]',
      3: 'lg:w-[calc(33.333%-13.333px)]',
      4: 'lg:w-[calc(25%-15px)]',
    }[numCols];

    return (
      <div className={`${window.location.pathname.includes('editor') && (["dt", "mob"].filter((i) => i === this.props.visibility).length) ? 'opacity-50 flex' : this.props.visibility == "dt" ? 'hidden lg:flex' : this.props.visibility == "mob" ? 'lg:hidden' : 'flex'}`}>
        <div className='container'>

              {/* Items here */}
              <div className={`flex flex-wrap ${Opt.toTailwindClasses(this.props.horizontalAlignContent)} items-stretch`}>
                {this.props.items.map((item, index) => {

                    return (
                      <div key={index} className={`w-full md:w-[calc(50%-10px)] ${lgWidthClass} my-[10px] px-[10px]`}>
                        <div className={`h-full flex items-start flex-col mt-[0px] ${item.showItemBackgroundColor === "yes" ? `bg-${item.backgroundColor} p-[20px] rounded-[20px]`: 'p-[20px] rounded-[20px]'}`}>
                          <div className='w-full lg:w-[33%-10px]'>

                            {/* icon or number here */}
                            {this.props.showIcon === 'yes' ? (
                              <div className={`bg-${item.imageBgColor} mb-[20px] rounded-[10px] py-[10px] flex align-center justify-center`} style={{ width: this.props.iconSize, height: this.props.iconSize }}>
                                <img alt={item.alt} src={`${item.src}`} className={`rounded-md ${item.iconColor}`} />
                              </div>
                            ) : (
                              <div className={`bg-${item.imageBgColor} mb-[20px] rounded-[10px] p-[10px] flex align-center justify-center`} style={{ width: '40px', height: '40px' }}>
                                <p className={`fs-5 ${item.numberColor}`}>{item.number}</p>
                              </div>
                            )}
                            
                          </div>

                          {/* header and text here */}
                          <p className={`fs-5 mb-[10px] ${item.headerColor}`}>{item.header}</p>
                          <div className='quill-text mb-[30px]' dangerouslySetInnerHTML={{ __html: item.body }}></div>

                          {/* button here */}
                          {item.showButton === "yes" && (
                            <div className='mb-[20px] mt-auto'>
                              <a href={item.href} className={`n-btn ${item.buttonSize} ${item.buttonOptions} ${item.buttonStyle}`}>
                                {item.buttonText}
                                <span>{item.buttonIconAfter && <img className={`ml-[5px] ${item.buttonIconColor}`} style={{ width: "18px", height: "18px" }} src={item.buttonIconAfter} />}</span>
                              </a>
                          </div>
                          )}
                          
                        </div>
                      </div>
                    );
                })}
              </div>
          </div>
        </div>
    );
  }
}

FeaturesLayout.defaultProps = {
  visibility: "",
  numberColumns: 3,
  showIcon: "yes",
  iconSize: "64px",
  horizontalAlignContent: 'justify-start',
  items: [
    {
      src: "https://placehold.co/600x400",
      alt: "scenic image",
      iconColor: 'neutral-charcoal-filter',
      imageBgColor: 'supp-forest-green',
      numberColor: 'neutral-charcoal',
      number: 1,
      header: 'Short heading here',
      headerColor: 'neutral-charcoal',
      body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.',
      showItemBackgroundColor: "yes",
      backgroundColor: 'neutral-cloud-500',
      showButton: "yes",
      buttonText: "Action",
      href: "/",
      buttonSize: "",
      buttonStyle: "btn-outline",
      buttonOptions: "btn-charcoal",
      buttonIconAfter: null,
      buttonIconColor: "neutral-charcoal-filter",
    },
    {
      src: "https://placehold.co/600x400",
      alt: "scenic image",
      iconColor: 'neutral-charcoal-filter',
      imageBgColor: 'supp-forest-green',
      numberColor: 'neutral-charcoal',
      number: 2,
      header: 'Short heading here',
      headerColor: 'neutral-charcoal',
      body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.',
      showItemBackgroundColor: "yes",
      backgroundColor: 'neutral-cloud-500',
      showButton: "yes",
      buttonText: "Action",
      href: "/",
      buttonSize: "",
      buttonStyle: "btn-outline",
      buttonOptions: "btn-charcoal",
      buttonIconAfter: null,
      buttonIconColor: "neutral-charcoal-filter",
    },
    {
      src: "https://placehold.co/600x400",
      alt: "scenic image",
      iconColor: 'neutral-charcoal-filter',
      imageBgColor: 'supp-forest-green',
      numberColor: 'neutral-charcoal',
      number: 3,
      header: 'Short heading here',
      headerColor: 'neutral-charcoal',
      body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros.',
      showItemBackgroundColor: "yes",
      backgroundColor: 'neutral-cloud-500',
      showButton: "yes",
      buttonText: "Action",
      href: "/",
      buttonSize: "",
      buttonStyle: "btn-outline",
      buttonOptions: "btn-charcoal",
      buttonIconAfter: null,
      buttonIconColor: "neutral-charcoal-filter",
    },
  ],
};

FeaturesLayout.fields = {
  visibility: {
    type: "select",
    options: Opt.visibilityOptions
  },
  numberColumns: {
    type: "select",
    options: Opt.colOptions
  },
  showIcon: {
    type: "select",
    options: [{ label: "Yes", value: "yes" }, { label: "No", value: "no" }]
  },
  iconSize: {
    type: "select",
    options: Opt.iconSizeOptions
  },
  horizontalAlignContent: {
    type: "select",
    options: Opt.contentJustify
  },
  items: {
    type: 'array',
    arrayFields: {
      src: {
        type: "custom",
        render: ({ name, onChange, value }) => <MediaSelector name={'icon'} type={'icon'} onChange={onChange} value={value} />,
      },
      alt: { type: "text" },
      iconColor:{
        type: "select",
        options: Opt.filterOptions
      },
      imageBgColor: {
        type: "custom",
        render: (props) => <ColorSelector {...props} />
      },
      numberColor: {
        type: "select",
        options: Opt.colorVariables
      },
      number: { type: "text" },
      header: { type: "text" },
      headerColor: {
        type: "select",
        options: Opt.colorVariables
      },
      body: { 
        type: "custom",
        render: ({ name, onChange, value }) => <TextEditor name={name} value={value} onChange={onChange} /> 
      },
      showItemBackgroundColor: {
        type: "select",
        options: [{ label: "Yes", value: "yes" }, { label: "No", value: "no" }]
      },
      backgroundColor:{
        type: "custom",
        render: (props) => <ColorSelector {...props} />
      },
      showButton: {
        type: "select",
        options: [{ label: "Yes", value: "yes" }, { label: "No", value: "no" }]
    },
      buttonText: { type: "text" },
      href: { type: "text" },
      buttonSize: {
        type: "select",
        options: Opt.buttonSize
      },
      buttonStyle: {
        type: "select",
        options: Opt.buttonStyle
      }, 
      buttonOptions: {
        type: "select",
        options: Opt.buttonOptions
      },
      buttonIconAfter: {
        type: "custom",
        render: ({ name, onChange, value }) => <MediaSelector name={'iconAfter'} type={'icon'} onChange={onChange} value={value} />,
      },
      buttonIconColor: {
        type: "select",
        options: Opt.filterOptions
      },     
    }, defaultItemProps: FeaturesLayout.defaultProps.items[0],
  },
}

export default FeaturesLayout;